import CustomSearchBox from '../algolia/CustomSearchBox';
import Union from '../icons/Union';
import clsx from 'clsx';

type StockistsIntroProps = {
  isInModal?: boolean;
};

export const StockistsIntro = (props: StockistsIntroProps) => {
  return (
    <div
      className={clsx('mx-auto max-w-[696px] space-y-3 ', {
        'px-5 lg:px-0': !props.isInModal,
      })}
    >
      {props.isInModal && <h3 className="blockH7 font-bold">Our retailers</h3>}
      <div>
        <div
          className={clsx(
            'flex w-fit items-center gap-x-[11px] pb-3',
            !props.isInModal && 'mx-auto',
          )}
        >
          <div>
            <Union />
          </div>
          <div>
            <p className="richH7 font-semibold">
              Our products fly off the shelves.
            </p>
            <p className="font-sans text-[15px]">
              Call ahead to ensure your nearest retailer has what you're looking
              for!
            </p>
          </div>
        </div>
      </div>
      <CustomSearchBox />
    </div>
  );
};
